import React from 'react';
import BaseDetailPage from '../../../_CustomComponents/BaseDetailPage';
import { Portlet, PortletBody, PortletHeader } from "../../../../../partials/content/Portlet";
import * as internalEstimateCrud from '../../../../../crud/internalEstimate.crud';
import { Alert } from "react-bootstrap";
import { withDetailPageProps } from '../../../../../shared/hoc/withDetailPageProps';
import BiDynamicForm from '../../../../../partials/layout/BiDynamicForm';

const initialState = {
    saving: false,
    isChanged: false,
    internalestimateid: null,
    priceimpact: 0,
    timeimpact: 0,
    internalnotes: '',
    status: 'ACTIVE',
    existingActiveEstimate: null,
    validationErrors: []
};

/**
 * Generic Internal Estimate Create Component
 * Works with any parent workflow (CE, EW, Instruction, Proposal)
 */
class InternalEstimateCreatePage extends BaseDetailPage {
    constructor(props) {
        super(props);

        this.createFormConfig = {
            currencyCode: this.props.contract.currency,
            buttonResource: "GENERAL.FORMS.BUTTON_CREATE",
            fields: [
                { label: props.workflowItem.fields.PriceImpact.label, dataField: 'priceimpact', editorType: 'dxNumberBox' },
                { label: props.workflowItem.fields.TimeImpact.label, dataField: 'timeimpact', editorType: 'dxNumberBox', editorOptions: { format: '#,##0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_DAYS' }), placeholder: '0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_DAYS' }) }, validation: { type: 'range', min: -36525, max: 36525, warning: this.props.intl.formatMessage({ id: 'ASSESSMENT.FORM.INVALID_DATE' }, { VALUE: 36525 }) } },
                { label: props.workflowItem.fields.InternalNotes.label, dataField: 'internalnotes', editorType: 'dxTextArea' }
            ]
        };

        this.state = { ...initialState };
        this.validatorRef = React.createRef();
        this.validatorName = 'InternalEstimateValidator';
    }

    componentDidMount() {
        this.checkExistingEstimate();
    }

    checkExistingEstimate = () => {
        if (!this.props.parentNotification?.lineageid) {
            return;
        }

        internalEstimateCrud.getActiveEstimate(this.props.parentNotification.lineageid)
            .then(response => {
                if (response.data.internalestimateid) {
                    this.setState({
                        existingActiveEstimate: response.data
                    });
                }
            })
            .catch(error => {
                console.error('Error fetching existing estimate:', error);
            });
    };

    handleInputChange = (field, value) => {
        this.setState({
            [field]: value,
            isChanged: true
        });
    };

    handleCommunicate = () => {
        if (this.validateForm()) {
            this.saveEstimate();
        }
    };

    validateForm = () => {
        const errors = [];

        if (this.state.priceimpact === null && this.state.timeimpact === null) {
            errors.push('At least one of Price Impact or Time Impact must be provided');
        }

        if (errors.length > 0) {
            this.setState({ validationErrors: errors });
            return false;
        }

        this.setState({ validationErrors: [] });
        return true;
    };

    saveEstimate = () => {
        this.setState({ saving: true });

        const estimateData = {
            notificationid: this.props.notificationid,
            workflowid: this.props.workflowItem.id,
            lineageid: this.props.parentNotification?.lineageid,
            priceimpact: this.state.priceimpact || 0,
            timeimpact: this.state.timeimpact || 0,
            internalnotes: this.state.internalnotes,
            contractid: this.props.contract.contractid,
            companyid: this.props.contract.companyid,
            projectid: this.props.contract.projectid
        };

        internalEstimateCrud.saveInternalEstimate(estimateData)
            .then(response => {
                this.setState({ 
                    saving: false,
                    isChanged: false,
                    internalestimateid: response.data
                });
                
                // Redirect to estimate detail page
                if (response.data) {
                    this.props.onParentChanged();
                    const basePath = this.props.workflowItem.paths.basePath;
                    this.props.navigate(`${basePath}${response.data}`);
                }
            })
            .catch(error => {
                this.setState({ 
                    saving: false,
                    validationErrors: [error.response?.data?.message || 'Error saving estimate']
                });
            });
    };

    render() {
        const { existingActiveEstimate } = this.state;

        return (
            <>
                <Portlet>
                    <PortletHeader title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.CREATE_TITLE' }, { ITEM_NAME: this.props.workflowItem.pageTitle })} />
                    <PortletBody style={{ maxWidth: 1000 }}>
                        {existingActiveEstimate && (
                            <Alert variant="warning">
                                <strong>Warning:</strong>&nbsp; An estimate for this Change Lineage currently contributes to forecasts.
                                This new estimate will {this.state.lifecyclestage === existingActiveEstimate.lifecyclestage 
                                    ? 'supersede the existing estimate' 
                                    : 'replace it based on the lifecycle priority hierarchy'}.
                            </Alert>
                        )}
                        <BiDynamicForm
                            validatorRef={this.validatorRef}
                            //item={this.props.item}
                            config={this.createFormConfig}
                            onSubmitHandler={this.saveEstimate}
                            valueChangeHandler={this.handleInputChange}
                        />
                    </PortletBody>
                </Portlet>
            </>
        );
    }
}

export default withDetailPageProps(InternalEstimateCreatePage);
